module.exports = __webpack_public_path__ + "static/media/feedback.760ca16a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/feedback.svg
// module id = 227
// module chunks = 1